import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const kanbanBoardV3Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Kanban Board element to v3 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'kanbanBoard'>): void => {
    const kanbanBoardProps = props;

    if (kanbanBoardProps?.style?.general?.heading && !kanbanBoardProps?.content?.title?.iconColor) {
      const currentColor = kanbanBoardProps.style.general.heading.color1;
      kanbanBoardProps.content = {
        ...kanbanBoardProps.content,
        title: {
          ...kanbanBoardProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
